// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3EgpX","savePackageButton":"ClientWallet_savePackageButton__K2E4O"};